export default __webpack_public_path__ + "assets/images/dbde9fadf7aba4a069628d284bc0babc.jpg";